// extracted by mini-css-extract-plugin
export var documentation = "_kp-1";
export var menu = "_kp-0";